import { useReducer } from 'react';

import { SetStateTuple, State } from '@/types/State';

// does not support setState callbacks
export default function useSetState(initialState: State): SetStateTuple {
    const [state, setState] = useReducer((state, newState) => ({ ...state, ...newState }), initialState);
    return [state, setState];
}
